import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentUser: {},
  email: "",
  loggedIn: false,
  toolTipTitle: "",
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
    },
    setEmail(state, action) {
      state.email = action.payload;
    },
    setLoggedIn(state, action) {
      state.loggedIn = action.payload;
    },
    setToolTipTitle(state, action) {
      state.toolTipTitle = action.payload;
    },
  },
});

export const { setCurrentUser, setEmail, setLoggedIn, setToolTipTitle } = userSlice.actions;
export default userSlice.reducer;